(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcmd-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcmd-cart')) {
    class TcmdCart extends HTMLElement {
      connectedCallback() {
        this.addUrl = this.dataset.addUrl;
        this.changeUrl = this.dataset.changeUrl;
        this.currency = this.dataset.currency || 'USD';
        this.status = this.querySelector('[data-cart-status]');
        this.checkoutButton = this.querySelector('[data-checkout-button]');
        this.timers = new Map();
        this.queue = Promise.resolve();
        this.pendingUpdates = 0;

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-quantity-step]');
          if (!button || !this.contains(button)) return;
          const line = button.closest('[data-cart-line]');
          const input = line.querySelector('[data-quantity-selector]');
          if (input.disabled || line.hasAttribute('aria-busy')) return;

          const current = this.isValidQuantity(input.value)
            ? Number(input.value)
            : Number(input.dataset.previousValue) || 1;
          const next = Math.max(1, current + Number(button.dataset.quantityStep));
          if (next === current) return;
          input.value = String(next);
          this.syncLineQuantityButtons(line);
          this.runQuantityUpdate(input);
        });

        this.addEventListener('input', (event) => {
          if (event.target.matches('[data-quantity-selector]')) {
            this.syncLineQuantityButtons(event.target.closest('[data-cart-line]'));
            this.scheduleQuantityUpdate(event.target);
          }
        });

        this.addEventListener('change', (event) => {
          if (event.target.matches('[data-quantity-selector]')) {
            this.runQuantityUpdate(event.target);
          }

          if (event.target.matches('[data-size-selector]')) {
            this.runSizeUpdate(event.target);
          }
        });
      }

      syncLineQuantityButtons(line) {
        const input = line.querySelector('[data-quantity-selector]');
        const busy = input.disabled || line.hasAttribute('aria-busy');
        const minus = line.querySelector('[data-quantity-step="-1"]');
        const plus = line.querySelector('[data-quantity-step="1"]');
        if (minus) minus.disabled = busy || !this.isValidQuantity(input.value) || Number(input.value) <= 1;
        if (plus) plus.disabled = busy;
      }

      scheduleQuantityUpdate(input) {
        const existingTimer = this.timers.get(input);
        if (existingTimer) window.clearTimeout(existingTimer);

        if (!this.isValidQuantity(input.value)) {
          this.timers.delete(input);
          this.setStatus('Enter a quantity of 1 or more.');
          this.syncCheckoutState();
          return;
        }

        if (input.value === input.dataset.previousValue) {
          this.timers.delete(input);
          this.syncCheckoutState();
          return;
        }

        const timer = window.setTimeout(() => {
          this.timers.delete(input);
          this.enqueue(() => this.updateQuantity(input));
          this.syncCheckoutState();
        }, 450);

        this.timers.set(input, timer);
        this.setStatus('Updating bag…');
        this.syncCheckoutState();
      }

      runQuantityUpdate(input) {
        const existingTimer = this.timers.get(input);
        if (existingTimer) {
          window.clearTimeout(existingTimer);
          this.timers.delete(input);
        }

        if (!this.isValidQuantity(input.value)) {
          input.value = input.dataset.previousValue;
          this.syncLineQuantityButtons(input.closest('[data-cart-line]'));
          this.setStatus('Quantity must be 1 or more. Use Remove to delete an item.');
          this.syncCheckoutState();
          return;
        }

        if (input.value === input.dataset.previousValue) {
          this.syncCheckoutState();
          return;
        }

        this.enqueue(() => this.updateQuantity(input));
        this.syncCheckoutState();
      }

      runSizeUpdate(select) {
        this.enqueue(() => this.updateSize(select));
        this.syncCheckoutState();
      }

      enqueue(task) {
        this.pendingUpdates += 1;
        this.syncCheckoutState();

        this.queue = this.queue.then(task, task).finally(() => {
          this.pendingUpdates -= 1;
          this.syncCheckoutState();
        });

        return this.queue;
      }

      async updateQuantity(input) {
        const line = input.closest('[data-cart-line]');
        const quantity = Math.max(1, Number.parseInt(input.value, 10));
        const previousValue = input.dataset.previousValue;

        input.value = quantity;
        line.setAttribute('aria-busy', 'true');
        input.disabled = true;
        this.syncLineQuantityButtons(line);
        this.setStatus('Updating bag…');

        try {
          const cart = await this.request(this.changeUrl, {
            id: line.dataset.lineKey,
            quantity
          });

          const updatedItem = cart.items.find((item) => item.key === line.dataset.lineKey);
          if (updatedItem) {
            input.dataset.previousValue = String(updatedItem.quantity);
            input.value = updatedItem.quantity;
            const linePrice = line.querySelector('[data-line-price]');
            if (linePrice) linePrice.textContent = this.formatMoney(updatedItem.final_line_price, false);
          }

          this.updateCartSummary(cart);
          this.setStatus('Bag updated.');
        } catch (error) {
          input.value = previousValue;
          this.setStatus(error.message || 'The bag could not be updated. Please try again.');
        } finally {
          line.removeAttribute('aria-busy');
          input.disabled = false;
          this.syncLineQuantityButtons(line);
        }
      }

      async updateSize(select) {
        const line = select.closest('[data-cart-line]');
        const quantityInput = line.querySelector('[data-quantity-selector]');
        const originalVariantId = line.dataset.variantId;
        const newVariantId = select.value;

        if (newVariantId === originalVariantId) return;

        const addItem = {
          id: Number(newVariantId),
          quantity: Math.max(1, Number.parseInt(quantityInput.value, 10) || 1)
        };
        const sellingPlan = line.dataset.sellingPlan;

        if (line.dataset.lineProperties) {
          const properties = JSON.parse(line.dataset.lineProperties || '{}');
          if (Object.keys(properties).length) addItem.properties = properties;
        }
        if (sellingPlan) addItem.selling_plan = Number(sellingPlan);

        line.setAttribute('aria-busy', 'true');
        select.disabled = true;
        quantityInput.disabled = true;
        this.syncLineQuantityButtons(line);
        this.setStatus('Updating size…');

        try {
          await this.request(this.addUrl, { items: [addItem] });
          await this.request(this.changeUrl, {
            id: line.dataset.lineKey,
            quantity: 0
          });
          window.location.reload();
        } catch (error) {
          select.value = originalVariantId;
          select.disabled = false;
          quantityInput.disabled = false;
          line.removeAttribute('aria-busy');
          this.syncLineQuantityButtons(line);
          this.setStatus(error.message || 'The size could not be updated. Please try again.');
        }
      }

      async request(url, body) {
        const response = await fetch(url, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(body)
        });
        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.description || result.message || 'The bag could not be updated.');
        }

        return result;
      }

      updateCartSummary(cart) {
        const total = this.querySelector('[data-cart-total]');
        if (total) total.textContent = this.formatMoney(cart.total_price, true);

        document.querySelectorAll('.cart-count').forEach((count) => {
          count.textContent = cart.item_count;
        });
      }

      formatMoney(cents, includeCurrency) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: this.currency,
          currencyDisplay: 'narrowSymbol'
        }).format(cents / 100);

        return includeCurrency ? `${amount} ${this.currency}` : amount;
      }

      setStatus(message) {
        if (this.status) this.status.textContent = message;
      }

      isValidQuantity(value) {
        const quantity = Number(value);
        return Number.isInteger(quantity) && quantity >= 1;
      }

      syncCheckoutState() {
        if (this.checkoutButton) {
          const hasInvalidQuantity = Array.from(this.querySelectorAll('[data-quantity-selector]')).some(
            (input) => !this.isValidQuantity(input.value)
          );
          this.checkoutButton.disabled = this.timers.size > 0 || this.pendingUpdates > 0 || hasInvalidQuantity;
        }
      }
    }

    customElements.define('tcmd-cart', TcmdCart);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcmd-hero-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tcmd-hero-carousel')) {
 customElements.define('tcmd-hero-carousel',class extends HTMLElement {
  connectedCallback(){
   this.slides=[...this.querySelectorAll('[data-hero-slide]')];
   this.selectors=[...this.querySelectorAll('[data-hero-select]')];
   this.modeButtons=[...this.querySelectorAll('[data-hero-mode]')];
   this.motion=this.querySelector('.tcmd-campaign-video');
   this.legacy=this.querySelector('.hero-video');
   this.reduced=matchMedia('(prefers-reduced-motion:reduce)');
   this.mode=this.reduced.matches?'still':'motion';
   this.index=0;
   this.visible=true;
   this.onClick=(event)=>{
    const select=event.target.closest('[data-hero-select]');
    if(select){this.show(Number(select.dataset.heroSelect));return;}
    if(event.target.closest('[data-hero-next]'))this.show(this.index+1);
    if(event.target.closest('[data-hero-prev]'))this.show(this.index-1);
    const mode=event.target.closest('[data-hero-mode]');
    if(mode){this.mode=mode.dataset.heroMode;this.sync();}
   };
   this.onKey=(event)=>{
    if(event.target!==this)return;
    if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1));}
   };
   this.onVisibility=()=>this.sync();
   this.onReduced=()=>{if(this.reduced.matches)this.mode='still';this.sync();};
   this.onPlaying=()=>this.slides[0].classList.add('is-motion');
   this.onError=()=>{this.mode='still';this.sync();};
   this.addEventListener('click',this.onClick);
   this.addEventListener('keydown',this.onKey);
   document.addEventListener('visibilitychange',this.onVisibility);
   this.reduced.addEventListener('change',this.onReduced);
   this.motion?.addEventListener('playing',this.onPlaying);
   this.motion?.addEventListener('error',this.onError);
   let touch=null;
   this.onTouchStart=(event)=>{if(event.target.closest('button,a'))return;touch={x:event.changedTouches[0].clientX,y:event.changedTouches[0].clientY};};
   this.onTouchEnd=(event)=>{if(!touch)return;const dx=event.changedTouches[0].clientX-touch.x;const dy=event.changedTouches[0].clientY-touch.y;touch=null;if(Math.abs(dx)>60&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));};
   this.addEventListener('touchstart',this.onTouchStart,{passive:true});
   this.addEventListener('touchend',this.onTouchEnd,{passive:true});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.1});
   this.observer.observe(this);
   this.sync();
  }
  show(index){
   this.index=(index+this.slides.length)%this.slides.length;
   this.slides.forEach((slide,i)=>{slide.hidden=i!==this.index;});
   this.selectors.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));
   const position=this.querySelector('[data-hero-position]');
   position.textContent=position.dataset.positionTemplate.replace('[number]',String(this.index+1));
   this.sync();
  }
  sync(){
   const canPlay=this.visible&&!document.hidden&&!this.reduced.matches;
   this.modeButtons.forEach(button=>{button.setAttribute('aria-pressed',String(button.dataset.heroMode===this.mode));button.disabled=button.dataset.heroMode==='motion'&&(!this.motion||this.reduced.matches);});
   if(this.index===0&&this.mode==='motion'&&canPlay&&this.motion){
    this.motion.muted=true;this.motion.playsInline=true;this.motion.play().catch(()=>{});
   }else{this.motion?.pause();if(this.mode==='still')this.slides[0].classList.remove('is-motion');}
   if(this.legacy){if(this.index===1&&canPlay){this.legacy.muted=true;this.legacy.playsInline=true;this.legacy.play().catch(()=>{});}else this.legacy.pause();}
  }
  disconnectedCallback(){
   this.motion?.pause();this.legacy?.pause();this.observer?.disconnect();
   this.removeEventListener('click',this.onClick);this.removeEventListener('keydown',this.onKey);
   this.removeEventListener('touchstart',this.onTouchStart);this.removeEventListener('touchend',this.onTouchEnd);
   document.removeEventListener('visibilitychange',this.onVisibility);this.reduced.removeEventListener('change',this.onReduced);
   this.motion?.removeEventListener('playing',this.onPlaying);this.motion?.removeEventListener('error',this.onError);
  }
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcmd-home"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('tcmd-shirt-carousel')) {
  customElements.define('tcmd-shirt-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.product-grid');
      this.prev = this.querySelector('[data-shirt-prev]');
      this.next = this.querySelector('[data-shirt-next]');
      this.desktop = matchMedia('(min-width:701px)');
      this.update = () => {
        const active = this.desktop.matches && this.track.clientWidth > 0;
        this.prev.disabled = !active || this.track.scrollLeft <= 2;
        this.next.disabled = !active || this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 2;
        if (active) this.track.setAttribute('tabindex', '0');
        else this.track.removeAttribute('tabindex');
      };
      this.move = (direction) => {
        const card = this.track.querySelector('.product-card:not([hidden])');
        if (!card) return;
        const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({left:direction * step,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
      };
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.onKey = (event) => {
        if (!this.desktop.matches || event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      };
      this.prev.addEventListener('click',this.onPrev);
      this.next.addEventListener('click',this.onNext);
      this.track.addEventListener('scroll',this.update,{passive:true});
      this.track.addEventListener('keydown',this.onKey);
      this.desktop.addEventListener('change',this.update);
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.prev.removeEventListener('click',this.onPrev);
      this.next.removeEventListener('click',this.onNext);
      this.track.removeEventListener('scroll',this.update);
      this.track.removeEventListener('keydown',this.onKey);
      this.desktop.removeEventListener('change',this.update);
      this.observer.disconnect();
    }
  });
}

if (!customElements.get('tcmd-story-carousel')) {
  customElements.define('tcmd-story-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.tcmd-war-track');
      this.cards = [...this.querySelectorAll('.tcmd-war-card')];
      this.prev = this.querySelector('[data-story-prev]');
      this.next = this.querySelector('[data-story-next]');
      this.count = this.querySelector('[data-story-count]');
      this.move = (step) => {
        const current = Math.round(this.track.scrollLeft / ((this.cards[0]?.offsetWidth || 1) + 16));
        const target = Math.max(0, Math.min(this.cards.length - 1, current + step));
        this.track.scrollTo({left:this.cards[target].offsetLeft - this.cards[0].offsetLeft, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      this.onPrev = () => this.move(-1);
      this.onNext = () => this.move(1);
      this.update = () => {
        if (!this.cards.length) return;
        const x = this.track.scrollLeft;
        let active = 0;
        this.cards.forEach((card, i) => {if (Math.abs(card.offsetLeft - this.cards[0].offsetLeft - x) < Math.abs(this.cards[active].offsetLeft - this.cards[0].offsetLeft - x)) active = i;});
        this.prev.disabled = x <= 2;
        this.next.disabled = x >= this.track.scrollWidth - this.track.clientWidth - 2;
        this.count.textContent = (active + 1) + ' / ' + this.cards.length;
      };
      this.prev.addEventListener('click', this.onPrev);
      this.next.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.update, {passive:true});
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.prev?.removeEventListener('click', this.onPrev);
      this.next?.removeEventListener('click', this.onNext);
      this.track?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcmd-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tcmd-product')) {
    class TcmdProduct extends HTMLElement {
      connectedCallback() {
        this.optionControls = Array.from(this.querySelectorAll('[data-option-control]'));
        this.variantInput = this.querySelector('[data-variant-id]');
        this.priceElement = this.querySelector('[data-product-price]');
        this.addButton = this.querySelector('[data-add-to-bag]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.quantityMinus = this.querySelector('[data-quantity-minus]');
        this.quantityPlus = this.querySelector('[data-quantity-plus]');
        this.mediaItems = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        this.galleryStage = this.querySelector('[data-gallery-stage]');
        this.galleryPrev = this.querySelector('[data-gallery-prev]');
        this.galleryNext = this.querySelector('[data-gallery-next]');
        this.galleryCount = this.querySelector('[data-gallery-count]');
        this.galleryThumbnails = this.querySelector('[data-gallery-thumbnails]');
        this.activeGalleryItems = [];
        this.currentSlide = 0;
        this.currentColor = null;
        this.variants = JSON.parse(this.querySelector('[data-variant-data]').textContent);
        this.optionControls.forEach((control) => control.addEventListener('change', () => this.updateProduct()));
        this.quantityMinus.addEventListener('click', () => this.changeQuantity(-1));
        this.quantityPlus.addEventListener('click', () => this.changeQuantity(1));
        this.quantityInput.addEventListener('change', () => this.normalizeQuantity());
        this.quantityInput.addEventListener('input', () => {
          this.quantityMinus.disabled = Number(this.quantityInput.value) <= 1;
        });
        this.galleryPrev.addEventListener('click', () => this.showSlide(this.currentSlide - 1));
        this.galleryNext.addEventListener('click', () => this.showSlide(this.currentSlide + 1));
        this.galleryStage.addEventListener('keydown', (event) => {
          if (event.target !== this.galleryStage) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            this.showSlide(this.currentSlide + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        let touchStart = null;
        this.galleryStage.addEventListener('touchstart', (event) => {
          if (this.inlineScale > 1) { touchStart = null; return; }
          if (event.target.closest('button, video, model-viewer, iframe')) return;
          touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
        }, { passive: true });
        this.galleryStage.addEventListener('touchend', (event) => {
          if (this.inlineScale > 1 || !touchStart || this.activeGalleryItems.length < 2) { touchStart = null; return; }
          const dx = event.changedTouches[0].clientX - touchStart.x;
          const dy = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
            this.showSlide(this.currentSlide + (dx < 0 ? 1 : -1));
          }
        }, { passive: true });
        this.setupZoom();
        this.updateProduct(false);
      }


      setupZoom() {
        const stage = this.galleryStage;
        const button = this.querySelector('[data-zoom-open]');
        this.inlineScale = 1;
        this.inlineX = this.inlineY = 0;
        this.paintInline = () => {
          if (!this.inlineImage) return;
          const lx=this.inlineImage.clientWidth*(this.inlineScale-1)/2;
          const ly=this.inlineImage.clientHeight*(this.inlineScale-1)/2;
          this.inlineX=Math.max(-lx,Math.min(lx,this.inlineX));
          this.inlineY=Math.max(-ly,Math.min(ly,this.inlineY));
          this.inlineImage.style.transform='translate('+this.inlineX+'px,'+this.inlineY+'px) scale('+this.inlineScale+')';
        };
        this.resetInline = () => {
          if(this.inlineImage) this.inlineImage.style.transform='';
          this.inlineScale=1;
          this.inlineX=this.inlineY=0;
          stage.classList.remove('is-zoomed','is-dragging');
          button.textContent=button.dataset.zoomLabel;
          button.setAttribute('aria-label',button.dataset.zoomLabel);
          button.setAttribute('aria-pressed','false');
        };
        const toggle = (x,y) => {
          if(this.inlineScale>1) { this.resetInline(); return; }
          const active=this.activeGalleryItems[this.currentSlide];
          const image=active && active.querySelector('img');
          if(!image) return;
          this.inlineImage=image;
          const rect=image.getBoundingClientRect();
          this.inlineScale=2.5;
          this.inlineX=(rect.left+rect.width/2-(x ?? rect.left+rect.width/2))*1.5;
          this.inlineY=(rect.top+rect.height/2-(y ?? rect.top+rect.height/2))*1.5;
          if(!image.dataset.zoomLoaded) {
            image.removeAttribute('srcset');
            image.src=active.dataset.zoomSrc;
            image.dataset.zoomLoaded='true';
          }
          stage.classList.add('is-zoomed');
          button.textContent=button.dataset.resetLabel;
          button.setAttribute('aria-label',button.dataset.resetLabel);
          button.setAttribute('aria-pressed','true');
          this.paintInline();
        };
        button.addEventListener('click',()=>toggle());
        let gesture=null,suppressClick=false;
        stage.addEventListener('pointerdown',e=>{
          if(!e.target.matches('[data-gallery-slide] img') || e.button!==0) return;
          gesture={id:e.pointerId,x:e.clientX,y:e.clientY,startX:this.inlineX,startY:this.inlineY,moved:false,zoomed:this.inlineScale>1};
          if(gesture.zoomed) { e.target.setPointerCapture(e.pointerId); stage.classList.add('is-dragging'); }
        });
        stage.addEventListener('pointermove',e=>{
          if(!gesture || gesture.id!==e.pointerId) return;
          const dx=e.clientX-gesture.x,dy=e.clientY-gesture.y;
          if(Math.hypot(dx,dy)>8) gesture.moved=true;
          if(gesture.zoomed) {
            this.inlineX=gesture.startX+dx; this.inlineY=gesture.startY+dy; this.paintInline();
          }
        });
        stage.addEventListener('pointerup',e=>{
          if(!gesture || gesture.id!==e.pointerId) return;
          suppressClick=gesture.moved; stage.classList.remove('is-dragging'); gesture=null;
        });
        stage.addEventListener('pointercancel',()=>{gesture=null;suppressClick=true;stage.classList.remove('is-dragging');});
        stage.addEventListener('click',e=>{
          if(!e.target.matches('[data-gallery-slide] img')) return;
          if(!suppressClick) toggle(e.clientX,e.clientY);
          suppressClick=false;
        });
        stage.addEventListener('dragstart',e=>{if(e.target.matches('img')) e.preventDefault();});
        stage.addEventListener('keydown',e=>{if(e.key==='Escape') this.resetInline();});
      }

      changeQuantity(delta) {
        const current = Math.max(1, parseInt(this.quantityInput.value, 10) || 1);
        const maximum = this.quantityInput.max ? parseInt(this.quantityInput.max, 10) : Infinity;
        this.quantityInput.value = Math.min(maximum, Math.max(1, current + delta));
        this.quantityMinus.disabled = Number(this.quantityInput.value) <= 1;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      normalizeQuantity() {
        const current = parseInt(this.quantityInput.value, 10);
        const maximum = this.quantityInput.max ? parseInt(this.quantityInput.max, 10) : Infinity;
        this.quantityInput.value = Math.min(maximum, Math.max(1, Number.isFinite(current) ? current : 1));
        this.quantityMinus.disabled = Number(this.quantityInput.value) <= 1;
      }

      updateProduct(updateUrl = true) {
        this.filterMedia();

        const optionIndexes = [...new Set(this.optionControls.map((control) => Number(control.dataset.optionIndex)))].sort((a, b) => a - b);
        const selectedOptions = optionIndexes.map((index) => {
          const selectedRadio = this.querySelector(`[data-option-control][data-option-index="${index}"]:checked`);
          const select = this.querySelector(`select[data-option-control][data-option-index="${index}"]`);
          return selectedRadio ? selectedRadio.value : select.value;
        });
        const variant = this.optionControls.length === 0
          ? this.variants[0]
          : this.variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));

        if (!variant) {
          this.addButton.disabled = true;
          return;
        }

        this.variantInput.value = variant.id;
        this.priceElement.textContent = variant.price;
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available ? this.addButton.dataset.addLabel : this.addButton.dataset.soldLabel;

        if (updateUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }
      }

      filterMedia() {
        const selectedColor = this.querySelector('[data-color-option]:checked');
        const colorHandle = selectedColor ? selectedColor.dataset.colorHandle : '';
        if (this.currentColor === colorHandle && this.activeGalleryItems.length) return;

        const matchingMedia = selectedColor
          ? this.mediaItems.filter((item) => item.dataset.mediaColor === colorHandle)
          : this.mediaItems;
        this.activeGalleryItems = matchingMedia.length ? matchingMedia : this.mediaItems;
        this.currentColor = colorHandle;
        this.galleryThumbnails.replaceChildren();

        this.activeGalleryItems.forEach((item, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = `gallery-thumbnail${item.classList.contains('product-media--needs-shadow') ? ' gallery-thumbnail--needs-shadow' : ''}${item.classList.contains('product-media--pair') ? ' gallery-thumbnail--pair' : ''}${item.classList.contains('product-media--background-match') ? ' gallery-thumbnail--background-match' : ''}`;
          button.style.setProperty('--studio-bg-alpha', item.dataset.studioBgAlpha || '0');
          button.setAttribute('aria-label', `View image ${index + 1} of ${this.activeGalleryItems.length}`);
          const image = document.createElement('img');
          image.src = item.dataset.thumbSrc;
          image.alt = '';
          image.loading = 'lazy';
          button.append(image);
          button.addEventListener('click', () => this.showSlide(index));
          this.galleryThumbnails.append(button);
        });

        const hasMultiple = this.activeGalleryItems.length > 1;
        this.galleryPrev.hidden = !hasMultiple;
        this.galleryNext.hidden = !hasMultiple;
        this.galleryThumbnails.hidden = !hasMultiple;
        this.showSlide(0);
      }

      showSlide(index) {
        if(this.resetInline) this.resetInline();
        if (!this.activeGalleryItems.length) return;
        this.currentSlide = (index + this.activeGalleryItems.length) % this.activeGalleryItems.length;
        const active = this.activeGalleryItems[this.currentSlide];
        this.mediaItems.forEach((item) => {
          if (item !== active) item.querySelectorAll('video').forEach((video) => video.pause());
          item.hidden = item !== active;
        });
        this.querySelector('[data-zoom-open]').hidden = !active.querySelector('img');
        this.galleryCount.textContent = `${this.currentSlide + 1} / ${this.activeGalleryItems.length}`;
        this.galleryCount.setAttribute('aria-label', `Image ${this.currentSlide + 1} of ${this.activeGalleryItems.length}`);
        Array.from(this.galleryThumbnails.children).forEach((button, buttonIndex) => {
          button.setAttribute('aria-current', buttonIndex === this.currentSlide ? 'true' : 'false');
        });
      }
    }

    customElements.define('tcmd-product', TcmdProduct);
  }

  } catch(e) { console.error(e); }
})();
})();
